import { render, staticRenderFns } from "./formContactDropdownLabelInput.vue?vue&type=template&id=0e0c4f6f&"
import script from "./formContactDropdownLabelInput.vue?vue&type=script&lang=js&"
export * from "./formContactDropdownLabelInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e0c4f6f')) {
      api.createRecord('0e0c4f6f', component.options)
    } else {
      api.reload('0e0c4f6f', component.options)
    }
    module.hot.accept("./formContactDropdownLabelInput.vue?vue&type=template&id=0e0c4f6f&", function () {
      api.rerender('0e0c4f6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/formContactDropdownLabelInput.vue"
export default component.exports